export default function Table() {
  const tables = document.querySelectorAll('.c-editable table');

  tables.forEach(table => {
    const wrapper = document.createElement('div');
    wrapper.style.overflow = 'auto';

    table.parentNode.insertBefore(wrapper, table);

    wrapper.appendChild(table);
  })  
}
